import { prewarmGoogleAuth } from "@/ajax/auth/signInWithGoogle";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/auth/signin/oauth/")({
  component: RouteComponent,
});

function RouteComponent() {
  useEffect(() => {
    prewarmGoogleAuth();
  }, []);

  return <div></div>;
}
